import IconItem from './icon_item';

export default class Undo extends IconItem {
  constructor() {
    super('undo', 'Ctrl+Z');
  }
}
